<template>
  <div>
    <v-data-table
      v-if="availabilities && availabilities.length > 0"
      :headers="headers"
      :items="availabilities"
      :loading="isAppLoading"
      :disable-sort="true"
      item-key="id"
      class="elevation-1"
    >
      <template v-slot:item.date="{ item }">
        {{ item.startDate | formatDate }} to <br/>
        <span v-if="item.endDate">{{ item.endDate | formatDate }}</span>
        <span v-else>N/A</span>
      </template>
      <template v-slot:item.daysOfWeek="{ item }">
        {{ item.daysOfWeek | formatDow }}<br/>
        {{ item.startTime | format24h }} - {{ item.endTime | format24h }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card class="mx-auto" max-width="400" width="200" tile>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  :to="{
                    name: 'TeacherAvailability',
                    params: { teacherId: teacher.id, id: item.id },
                  }"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Edit Availability</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="deleteSchedule(item)">
                  <v-list-item-icon class="mr-2">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Delete Availability</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-menu>
      </template>
    </v-data-table>

    <div class="ma-10" v-else>
      <v-alert type="info" colored-border
            color="secondary" border="left" class="ma-5"> No availabilities defined </v-alert>
      <br />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  props: {
    teacher: {
      type: Object,
      required: true,
    },
  },
  filters: {
    joinString(value) {
      if (value && value.length > 0) {
        return value
          .map((v) => moment(v).format("ddd, MMM DD YYYY"))
          .join(", ");
      } else {
        return "";
      }
    },
    formatDate(value) {
      return moment(value).format("ddd, MMM DD YYYY");
    },
    format24h(value) {
      return moment(value, "HH:mm:ss").format("h:mm a");
    },
    formatDow(value) {
      if(value){
        return value.join(', ')
      }
      else{
        return ''
      }
    },
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      availabilities: [],
      headers: [
        { text: "Dates", value: "date" },
        { text: "Day of Week", value: "daysOfWeek" },
        { text: "Online Only", value: "onlineOnly" },
        { text: "Remark", value: "remark" },
        { text: "", value: "actions" },
      ],
      page: {
        pageIndex: 1,
        totalCount: 0,
        itemPerPage: 10,
      },
    };
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
  },
  mounted() {
    this.firstName = this.teacher.firstName;
    this.lastName = this.teacher.lastName;
    this.email = this.teacher.email;

    this.loadAvailabilities();
  },
  methods: {
    ...mapActions(["hideDialog", "addErrorMessage", "addSuccessMessage"]),

    deleteSchedule(schedule) {
      if (confirm("Please confirm you want to delete this schedule")) {
        const data = { id: schedule.id };

        this.$axios
          .post("/teachers/availability/delete", data)
          .then(() => {
            this.addSuccessMessage("Schedule deleted");
            this.availabilities.splice(
              this.availabilities.findIndex((a) => a.id == schedule.id),
              1
            );
          })
          .catch((error) => {
            this.addErrorMessage(error.message);
          });
      }
    },
    loadAvailabilities() {
      const startDate = new moment().format("YYYY-MM-DD");
      const endDate = new moment().add(1, "years").format("YYYY-MM-DD");
      const data = {
        start_date: startDate,
        end_date: endDate,
        teacherId: this.teacher.id,
        sortInfos: [
          {
            sortCol: "startDate",
            sortDir: "asc",
          },
        ],
      };
      this.$axios.post("/teachers/availability/search", data).then((resp) => {
        let list = resp.data.data.content;

        this.availabilities = list;
      });
    },
  },
};
</script>

<style>
</style>